<template>
      <div class="vsebina ">

    <div class="glava_vsebine adapt v-adapt">

      <div class="cols">
      <div class="col left grid-col-6">
        <h1>{{$route.query.title}}</h1>
      </div>
      
      
      
      <div class="col right">
      </div>
      
      </div>
    </div>
    
    <div class="telo_vsebine adapt v-adapt">
      <div>
        <div :style="{ display: 'inline-block' }">
            Sezona
            <br />
            <dropdownlist
                :data-items="sezonePisanje"
                :text-field="'sezona'"
                @change="sezonaChange"
                :value="dataSezona"
              
            />
          </div>
        </div>
      
    <div class="uporabnik-spacer" style="margin-top:2rem"></div>
     <div class="columnBar">
        Skriti stolpci:
              <multiselect 
                        :data-items="columns"
                        :text-field="'title'"
                        :data-item-key="'field'"
                        :placeholder="'Skrij stolpce'"
                        @change="spremenistolpce($event)"
                        
                        :auto-width="true"
                        :value="hiddenColumns2"
                        >
            </multiselect>
        </div>
        <div class="grid-wrapper">
        <Grid  
                       
                        :sortable="sortable"
                        :filterable="filterable"
                        :groupable="groupable"
                        :pageable="pageable"
                        :data-items="dataResult"
                        :skip="skip"
                        :row-render="rowRenderFunction"
                        :take="take" 
                        :sort="sort" 
                        :pageSize="pageSize"
                        :filter="filter" 
                        :columns="columns"
                        @datastatechange="dataStateChange"
                        @pagechange="pageChangeHandler"
                        
                       :resizable="true"
                        
                  
                       
                        >



                    <template v-slot:filterIPTemplate="{props, methods}">
            <div>
              <dropdownlist 
                :data-items="ipsheme"
                :style="{ width: '60px' }" 
                :text-field="'naziv'"
                v-model="izbranIPShema"
                :data-item-key="'id'"
                
            />
            <dropdownlist 
                :style="{ width: '100px' }" 
                :data-items="ipstatus"
                :text-field="'naziv'"
                v-model="izbranIPStatus"
                :data-item-key="'id'"
                
            />
            <button class="k-button" @click="filterIP"><span class="k-select"><span class="k-icon k-i-filter k-icon"></span></span>
            </button>
            <button class="k-button" @click="filterIPPocisti" title="Počisti"><span class="k-select"><span class="k-icon k-i-filter-clear k-icon"></span></span></button>
              </div>
             
          </template>

          <template v-slot:filterPrijavaTemplate="{props, methods}">
            <div>
        <div class="km-widget km-buttongroup k-widget k-button-group k-button-narrow">
            <button class="k-button k-primary" @click="filterPopolnePrijave" title="Popolne"> 
                <font-awesome-icon icon="edit"/>
            </button>
            <button class="k-button k-info" @click="filterPoslanePrijave" title="Poslane"> <font-awesome-icon icon="edit"/></button>
            <button class="k-button k-warning" @click="filterPrejetePrijave" title="Prejete"> <font-awesome-icon icon="edit"/></button>
            <button class="k-button k-error" @click="filterNeposlanePrijave" title="Neposlane"> <font-awesome-icon icon="edit"/></button>
            <button class="k-button" @click="filterVsePrijave" title="Vse"> <font-awesome-icon icon="edit"/></button>
            
        </div>
            </div>
             
          </template>


                    <template v-slot:filterSlotTemplate="{props, methods}">
            <div>
              <dropdownlist

                :data-items="kategorije"
                :text-field="'kratkinaziv'"
                @change="filterKategorijaChange"
             
                
            /></div>
          </template>
            
              <template v-slot:filterVrsteSlotTemplate="{props, methods}">
            <div>
              <dropdownlist
                :data-items="vrste"
                :text-field="'naziv'"
                
            /></div>
          </template>
            
              
              
            <template v-slot:shemaCommandCellSlot="{props, methods}">
                      <shemaCommandCell :ukazi="ukazi" :dataItem="props.dataItem" :shema="$route.query.title" :sezona="dataSezona.sezona"/>
            </template>



                     <template v-slot:shemaCell="{props}">
                      <shemaCell :sheme="props.dataItem.sheme"/>
                    </template>

                    <template v-slot:kategorijaCell="{props}">
                      <listCell :list="props.dataItem.sheme.find(s=>s.sezona==dataSezona.sezona&&s.shema==$route.query.title).kategorije.map(i=>i.id?i.id:i)"
                      
                        :displayname="'kratkinaziv'"
                        hover="naziv"
                        :sifrant="kategorije"
                        sifrantid="id"
                        :data-item="props.dataItem" 
                        dataitemname="kategorije"

                        />
                    </template>
                    <template v-slot:dejavnstiCell="{props}">
                      <listCell :list="props.dataItem.sheme.find(s=>s.sezona==dataSezona.sezona&&s.shema==$route.query.title).dejavnosti"
                      
                             :displayname="'naziv'"
                              :data-item="props.dataItem" 
                               dataitemname="dejavnosti"
                        />
                    </template>
                    <template v-slot:dejavnstivseCell="{props}">
                      <listCell :list="props.dataItem.sheme.find(s=>s.sezona==dataSezona.sezona&&s.shema==$route.query.title).vsedejavnosti"
                                           
                             :displayname="'naziv'"
                              :data-item="props.dataItem" 
                               dataitemname="dejavnosti"
                        />
                    </template>
                    <template v-slot:obseg="{props}">
                      <listCell :list="props.dataItem[props.field+'_array']"
                      :simple="true"                                                                               
                              :data-item="props.dataItem" 
                             
                        />
                    </template>
                    <template v-slot:obsegsifre="{props}">
                      <listCell :list="props.dataItem[props.field]"
                            :simple="true"                                                                            
                              :data-item="props.dataItem" 
                             
                        />
                    </template>
                    <template v-slot:statusCell="{props}">
                      <td colspan="1"><span>
                        {{ props.dataItem.sheme.find(s=>s.sezona==dataSezona.sezona&&s.shema==$route.query.title).status }}
</span></td>
                    </template>

                     <template v-slot:cbItem="{props}">
                      <cbItem :checked="props.dataItem[props.field]"/>
                    </template>
                 

                    <template v-slot:ipCell="{props}">
                      <ipshemacell :list="ippodrocjecertificiranja(props.dataItem)"
                            
                        />
                    </template>


                        <toolbar>
                             
                        <div class="km-widget km-buttongroup k-widget k-button-group">
                     
                       <!--
                             <button v-if="userDetails.pravice.includes('STRANKE_PISI')"
                                title="Dodaj KMG"
                                class="k-button k-primary"
                                @click="dodajPridelovalca"
                            >
                                Dodaj
                            </button>
                        -->
                            
                             <button
                                title="Izvozi v Excel"
                                class="k-button k-primary"
                                @click="exportExcel"
                            >
                                Izvozi v Excel
                            </button>
                           
                        </div>
                            
                        </toolbar>
                        <GridNoRecords >
                                        Ni podatkov!
                         </GridNoRecords>
                    </Grid>
                    <div class="shema-loader" v-if="loading"><font-awesome-icon icon="circle-notch" spin="spin"/></div>
                </div>

                    </div>
    </div>

</template>
<style lang="scss">

.k-grid .k-table-row.dislociranaenota {
    background-color: var(--info);
}
    .grid-wrapper {
        position: relative;
    }
    .shema-loader {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        font-size: 4rem;
        background-color: rgba(255,255,255,.5);
        color: var(--accent);
        text-align: center;
      }
</style>

<script>
import { mapState, mapActions,mapMutations } from 'vuex'

import '@progress/kendo-theme-default/dist/all.css'
import Vue from 'vue';

import kulture from './support/kulture-data';
import { Grid, GridToolbar,GridNoRecords } from '@progress/kendo-vue-grid';
import { MultiSelect, DropDownList } from '@progress/kendo-vue-dropdowns';
//import { saveExcel } from '@progress/kendo-vue-excel-export';
//import { MultiSelect } from '@progress/kendo-dropdowns-vue-wrapper';
import ShemaCell from './support/ShemaCell';
import ListCell from './support/ListCell';
import IPShemaCell from './support/IPShemaCell';
import ShemaCommandCell from './support/ShemaCommandCell';

import CheckBoxGridItem from './support/CheckBoxGridItem';


import { process } from '@progress/kendo-data-query';








export default {
     props:["sezona"],
      components:{
       'multiselect':MultiSelect,
      'dropdownlist': DropDownList,
      'shemaCell': ShemaCell,
      'listCell': ListCell,
      'ipshemacell': IPShemaCell,
      'shemaCommandCell': ShemaCommandCell,
      'cbItem': CheckBoxGridItem,
  //    'sifkontroleddcell': SifrantKontroleDownCell,
      'Grid': Grid,
      'GridNoRecords': GridNoRecords,
      'toolbar': GridToolbar,
 
  },
    data () {
        return {
            dataSezona:this.sezona,
            
          
           
            girdDataApi:null,
            gridData:null,
            loading:true,
            hiddenColumns2:[],
             
            editID: null,
            skip: 0,
            take: 10,
            pageSize: 10,
            sortable: true,
            filterable: true,
            groupable: false,
            ipsheme:[{naziv:"IPS",id:1},{naziv:"IPG",id:2},{naziv:"IPP",id:3},{naziv:"IPZ",id:4},{naziv:"IPH",id:5}], 
            ipstatus:[{naziv:"neaktiven",id:0},{naziv:"aktiven",id:1},{naziv:"mirovanje",id:2},{naziv:"odstop",id:3}],
            expandedItems: [],
            dataResult: [],
            izbranIPStatus:'',
            izbranIPShema:'',
         
            sort: [
                { field: 'ime', dir: 'asc' }
            ],
           
           ukazi:[],
           kategorije:[],
           vrste:[]

            

        }
    },
    created () {

            

        this.naloziPodatke(this.$route.query.title,this.$route.query.sezona);






     },
     beforeRouteUpdate (to, from,next) {
    
         this.naloziPodatke(to.query.title,to.query.sezona,next);

         /*
        if(!this.$route.query.sezona)
            this.dataSezona={sezona:2022};
        else
            this.dataSezona={sezona:this.$route.query.sezona};
        
        this.loadShema({sezona:this.dataSezona.sezona,shema:to.query.title}).then(x=>{
       
            this.ukazi=this.sheme.find(i=>i.kratica==to.query.title).ukazi;
            
            next();
        });
        
    
*/
 
    },



    computed: {

         pageable(){
            return { buttonCount: 4, pageSizes: [10,100,this.pridelava?.length] }
        },
        filter:{
            get(){
                return this.storedfilter;
            },
            set(value){
                this.updatefilter(value);
            }
        },

        ...mapState('pridelava', ['pridelava','storedfilter']),
         ...mapState('sifrant', ['sifrant','dataSezone']),
        ...mapState('users', ['userDetails','sezonePisanje','sheme']),
        hiddenColumns:{
            get(){
                return this.columns.filter(c=>c.hidden);
            }
            
            
        },
        columns() {

            let columns=[
                
                { field: "naziv", title:"Naziv"},
                { field: "id", title:"Kontrolna št.",width:"80px"},
                { field: "kmgmid", title:"KMG-MID",hidden:true},
                { field: "naslov", title:"Naslov",width:"150px"},
                { field: "postnastevilka", title:"Poštna št.",width:"80px"},
                { field: "posta", title:"Pošta"},
                //{ field: "obcina", title:"Občina",hidden:true},
                //{ field: "statisticnaregija", title:"Statistična regija KMG"},
                //{ field: "naslovnosilca", title:"Naslov nosilca",hidden:true},
                //{ field: "postnastevilkanosilca", title:"Poštna št. nosilca",hidden:true},
                //{ field: "postanosilca", title:"Pošta nosilca",hidden:true},
                //{ field: "statuspridelovalca", title:"Status"},
                //{ field: "datumdolocitvestatusa", title:"Datum določitve statusa", filterable:false, type:"date",format: '{0:d}', hidden:true},
                { field: "davcnastevilka", title:"Davčna številka",hidden:true},
                { field: "mso", title:"MŠO",hidden:true},
                //{ field: "vrstaPridelovalca", title:"Vrsta pridelovalca",hidden:true},
                //{ field: "imavezanezivali", title:"Vezana reja",hidden:true},
                //{ field: "imatravojedezivali", title:"Travojede živali",hidden:true},
                //{ field: "sheme", title:"Sheme",cell:"shemaCell",filterCell: 'filterSlotTemplate'},
                { field: "jeaktivna", title:"V kontroli",cell:"cbItem", hidden:true},
                
            ];

            //if(this.userDetails.pravice.includes("STRANKE_PISI"))
                columns.unshift({ title: "Ukazi", cell: "shemaCommandCellSlot",filterable:false,columnMenu: null,width:((this.ukazi.length*28)+6)+"px",sortable:false});

            //if(this.userDetails.pravice.includes("STATISTIKA_BERI"))
              //  columns.push({ field: "kontrolnaorganizacija", title:"V kontroli pri"});
              
              
              if(this.$route.query.title=="EKO PRI"){
                
                columns.push({field:"kategorije", title:"Kategorije",cell:"kategorijaCell",});
                columns.push({field:"dejavnosti" ,title:"Certificirane dejavnosti",cell:"dejavnstiCell",});
                columns.push({field:"vsedejavnosti" ,title:"Vse dejavnosti",cell:"dejavnstivseCell", hidden:true});
                columns.push({field:"status.status" ,title:"Status"});
                //{ field: "sheme", title:"Dejavnosti",cell:"shemaCell",filterCell: 'filterSlotTemplate'},
              }
              else if(this.$route.query.title=="IP"){
                columns.find(c=>c.title=="Ukazi").width=((this.ukazi.length*28)+56)+"px";
                columns.find(c=>c.field=="kmgmid").hidden=false;
                columns.splice(4,0,{field:"ippodrocja", title:"Področja",cell:"ipCell",filterCell:"filterIPTemplate",width:"240px"});

                for(let podshema of this.ipsheme){
                columns.splice(4,0,{field:podshema.naziv, title:"Obseg "+podshema.naziv,cell:"obseg",width:"240px", hidden:true});
                columns.splice(4,0,{field:podshema.naziv+"_sifra", title:"Šifre obsega "+podshema.naziv,cell:"obseg",width:"240px", hidden:true});
                }
                
                let ukazC=columns.find(c=>c.cell=="shemaCommandCellSlot");
                ukazC.filterCell="filterPrijavaTemplate";
                ukazC.filterable=true;
                
                columns.splice(8,0,{ field: "postakmg", title:"Pošta KMG", hidden:true})
                columns.splice(8,0,{ field: "postnastevilkakmg", title:"Poštna št.KMG", hidden:true})
                columns.splice(8,0,{ field: "naslovkmg", title:"Naslov KMG", hidden:true})
                columns.splice(8,0,{ field: "emailoo", title:"E-pošta"})
                columns.splice(8,0,{ field: "telefonoo", title:"Telefon"})
                //columns.splice(8,0,{ field: "povrsinaIP", title:"Površina (a)",hidden:true})
                columns.push({ field: "povrsinaIP", title:"Površina (a)",hidden:true})
                
                columns.find(c=>c.cell=="shemaCommandCellSlot").filterCell="filterPrijavaTemplate";
            
            } 

            
            if(this.$route.query.title=="EKO PRI"){
                columns.splice(8,0,{ field: "email", title:"E-pošta"})
                columns.splice(8,0,{ field: "telefon", title:"Telefon"})
                columns.push({ field: "spletnastran", title:"Spletna stran", hidden:true})
                columns.push({ field: "neoznacenigerki", title:"Število neshranjenih gerkov", hidden:true});
                columns.push({ field: "travojedezivali", title:"Travojede živali",hidden:true});
                columns.push({ field: "vezanareja", title:"Vezana reja",hidden:true,filter:'boolean',cell:"cbItem"});
                columns.push({ field: "statuslani", title:"Status lani",hidden:true});
                columns.push({ field: "povrsina_p", title:"Površina P (a)", hidden:true});
                columns.push({ field: "povrsina_eko", title:"Površina EKO (a)", hidden:true});
                columns.push({ field: "povrsina_skupaj", title:"Površine (a)", hidden:true});
                columns.push({ field: "tocke_povrsina", title:"Točke površine", hidden:true});
                columns.push({ field: "kolicina", title:"Količina", hidden:true});
                columns.push({ field: "tocke_kolicina", title:"Točke količine", hidden:true});
                columns.push({ field: "tocke_ket_k", title:"Točke KET Kulture", hidden:true});
                columns.push({ field: "tocke_ket_z", title:"Točke KET Živali", hidden:true});
                columns.push({ field: "nosilecddk", title:"Nosilec dopolnile dejavnosti", hidden:true,filter:'boolean',cell:"cbItem"});
                columns.push({ field: "spremembapodatkov", title:"Sprememba podatkov", hidden:true,filter:'boolean',cell:"cbItem"});
                let ukazC=columns.find(c=>c.cell=="shemaCommandCellSlot");
                //ukazC.filterCell="filterPrijavaTemplate";
                //ukazC.filterable=true;
                //{ field: "sheme", title:"Dejavnosti",cell:"shemaCell",filterCell: 'filterSlotTemplate'},
              }

               if(this.$route.query.title=="EKO PRE"){
                let indexC = columns.findIndex(obj => obj.field === "kmgmid");
                if (indexC !== -1) {
                    columns.splice(indexC, 1);
                }
                columns.push({field:"dejavnosti" ,title:"Certificirane dejavnosti",cell:"dejavnstiCell",});
                columns.push({field:"vsedejavnosti" ,title:"Vse dejavnosti",cell:"dejavnstivseCell", hidden:true});
                columns.push({field:"status.status" ,title:"Status"});
                columns.push({ field: "glavnadejavnost.vrstaproizvoda", title:"Glavna dejavnost", hidden:false})
                columns.push({ field: "shemaletos.vrstapredelovalca", title:"Vrsta predelovalca", hidden:false})
                columns.push({ field: "proizvodprikaz", title:"Proizvodi", hidden:false})
               

            }


            this.hiddenColumns2=columns.filter(c=>c.hidden);
            return columns;


        }

           },
      watch: {

       

        skip(newValue, oldValue){
           

            const dataState = {
            skip: this.skip,
            take: this.take,
            sort: this.sort,
             filter: this.filter,
            group: this.group
        };
        this.dataResult = process( this.pridelava, dataState);
        },
        take(newValue, oldValue){
         
       /*  if(isNaN(this.take))
            this.take=this.pridelava.length;
         */   
            const dataState = {
                skip: this.skip,
                take: this.take,
                sort: this.sort,
                 filter: this.filter,
                group: this.group
            }
        this.dataResult = process( this.pridelava, dataState);
        },
       pridelava(newValue, oldValue) {
    

      if(newValue){
        const dataState = {
            skip: this.skip,
            take: this.take,
            sort: this.sort,
             filter: this.filter,
            group: this.group
        };
        this.dataResult = process( this.pridelava, dataState);
        }
    }
},
    methods: {


        rowRenderFunction: function (h, trElement , defaultSlots, props ) {
            console.log(trElement);
            console.log(props.dataItem);
            if(props.dataItem.jedislocirana)
                trElement.data.class+=" dislociranaenota";
                return trElement;
            },
             nogaNazivVsot: function (h, emptyElement , props, listeners ) {
            return h('span', {}, ['Vsota:']);
        },
        ...mapActions('pridelava', ['load','replace','loadShema']),
        ...mapActions({naloziSifrant: 'sifrant/load'}),
        ...mapMutations('pridelava',['updatefilter']),
        ippodrocjecertificiranja(dataItem){
            return dataItem.sheme.find(s=>s.sezona==this.dataSezona.sezona&&s.shema==this.$route.query.title)?.ip?.podrocjacertificiranja
        },
        spremenistolpce (event)  {
			let value=event.target.value;
            for (let col of this.columns){
                if(value.find(i=>i.field==col.field)){
                    if(!col.hidden){
                    Vue.set(col,"hidden",true)
                    console.log("skrivam")
                }
            }
                else{
                    if(col.hidden){
                    Vue.set(col,"hidden",false)
                    console.log("odkrivam")
                    }
            }
                    
            }
                console.log(this.columns);

                const dataState = {
                skip: this.skip,
                take: this.take,
                sort: this.sort,
                filter: this.filter,
            
            };
            this.dataResult = process( this.pridelava, dataState);
            this.hiddenColumns2=this.columns.filter(c=>c.hidden);
			//let pridelava=this.pridelovalec.sheme.find(s=>s.sezona==this.sezona&&s.shema==this.shema);
            //Vue.set(this.ip.prijava.obseg,podshema,[...event.target.value])
			//console.log(this.ip.prijava.obseg);
        },
        filterPopolnePrijave(){
           

            var filter=this.filter.filters.find(f=>f.field=="eprijavastatus");
           if(!filter){
               filter={};
            this.filter.filters.push(filter);
            }

                filter.field='eprijavastatus';
                filter.value=1;
                filter.operator=function(itemValue, filterValue){
                    return itemValue.popolnaprijava;
                }


            const dataState = {
            skip: this.skip,
            take: this.take,
            sort: this.sort,
             filter: this.filter,
            group: this.group
        };
        this.dataResult = process( this.pridelava, dataState);
        },
        filterPoslanePrijave(){


           var filter=this.filter.filters.find(f=>f.field=="eprijavastatus");
           if(!filter){
               filter={};
            this.filter.filters.push(filter);
            }

                filter.field='eprijavastatus';
                filter.value=1;
                filter.operator=function(itemValue, filterValue){
                    return itemValue.eprijavaposlana&&!itemValue.popolnaprijava&&!itemValue.eprijavaoddana;
                }


            const dataState = {
            skip: this.skip,
            take: this.take,
            sort: this.sort,
             filter: this.filter,
            group: this.group
        };
        this.dataResult = process( this.pridelava, dataState);
        },
        filterPrejetePrijave(){
          
          
           var filter=this.filter.filters.find(f=>f.field=="eprijavastatus");
           if(!filter){
               filter={};
            this.filter.filters.push(filter);
            }

                filter.field='eprijavastatus';
                filter.value=1;
                filter.operator=function(itemValue, filterValue){
                    return itemValue.eprijavaoddana&&!itemValue.popolnaprijava;
                }


            const dataState = {
            skip: this.skip,
            take: this.take,
            sort: this.sort,
             filter: this.filter,
            group: this.group
        };
        this.dataResult = process( this.pridelava, dataState);
        },
        filterNeposlanePrijave(){
          
          
          var filter=this.filter.filters.find(f=>f.field=="eprijavastatus");
          if(!filter){
              filter={};
           this.filter.filters.push(filter);
           }

               filter.field='eprijavastatus';
               filter.value=1;
               filter.operator=function(itemValue, filterValue){
                   return !itemValue.eprijavaoddana&&!itemValue.popolnaprijava&&!itemValue.eprijavaposlana;
               }


           const dataState = {
           skip: this.skip,
           take: this.take,
           sort: this.sort,
            filter: this.filter,
           group: this.group
       };
       this.dataResult = process( this.pridelava, dataState);
       },
        filterVsePrijave(){

            var filter=this.filter.filters.find(f=>f.field=="eprijavastatus");
            this.filter.filters.splice(this.filter.filters.indexOf(filter),1);
          
            
             
            const dataState = {
            skip: this.skip,
            take: this.take,
            sort: this.sort,
             filter: this.filter,
            group: this.group
        };
        this.dataResult = process( this.pridelava, dataState);
        },
              filterIP(){
              

                var filter=this.filter.filters.find(f=>f.field=="sheme");
                var thisComp=this;
                
                if(this.izbranIPShema==''){
                    this.filter.filters.splice(this.filter.filters.indexOf(filter),1);
                    return;
                }

                if(!filter){
                    filter={};
                    this.filter.filters.push(filter);
                    }

                filter.field='sheme';
                filter.value=this.izbranIPShema;
                filter.operator=function(itemValue, filterValue){
                            //itemavlue so sheme
                            let shema=itemValue.find(s=>s.sezona==thisComp.dataSezona.sezona&&s.shema==thisComp.$route.query.title)
                            if(!shema)
                                return false;
                           let status=thisComp.izbranIPStatus;
                            if(shema.ip.podrocjacertificiranja.find(p=>p.naziv==filterValue.naziv&&p.status.id!=0&&(status==''||status?.id==p.status.id)))
                                return true;
                            

                            return false;
                            
                        }
            for (let p of this.pridelava){
                let tempshema=p.sheme.find(s=>s.shema==thisComp.$route.query.title&&s.sezona==thisComp.dataSezona.sezona);
                 let status=thisComp.izbranIPStatus==""?1:thisComp.izbranIPStatus.id;
                p.ippodrocja=tempshema.ip.podrocjacertificiranja.filter(pp=>pp.status.id==status).map(pp=>pp.naziv).join(" ");    
            }
                       const dataState = {
            skip: this.skip,
            take: this.take,
            sort: this.sort,
             filter: this.filter,
            group: this.group
        };
        this.dataResult = process( this.pridelava, dataState);
    },
        filterIPPocisti(){
                 var filter=this.filter.filters.find(f=>f.field=="sheme");
                this.filter.filters.splice(this.filter.filters.indexOf(filter),1);
                this.izbranIPShema ='';
                this.izbranIPStatus ='';

                const dataState = {
                skip: this.skip,
                take: this.take,
                sort: this.sort,
                 filter: this.filter,
                group: this.group
            };
            this.dataResult = process( this.pridelava, dataState);
        },

        naloziPodatke(shema,sezona,next){
        this.loading=true;
            if(!sezona)
            this.dataSezona={sezona:this.$trenutnasezona};
        else
            this.dataSezona={sezona:parseInt(sezona)};

        var thisComp=this;
        

         this.naloziSifrant({sezona:this.dataSezona.sezona,sifrant:"kategorije"}).then(()=>{

            thisComp.kategorije=thisComp.sifrant["kategorije"];   
            this.naloziSifrant({sezona:this.dataSezona.sezona,sifrant:"vrstapridelovalca"}).then(()=>{
            thisComp.vrste=thisComp.sifrant["vrstapridelovalca"];
            thisComp.loadShema({sezona:thisComp.dataSezona.sezona,shema:shema}).then(t=>{
             


                for (var p of thisComp.pridelava){
                    let tempshema=p.sheme.find(s=>s.shema==shema&&s.sezona==thisComp.dataSezona.sezona);
                    let lanishema=p.sheme.find(s=>s.shema==shema&&s.sezona==thisComp.dataSezona.sezona-1);

                    Vue.set(p,'shemaletos',tempshema)
                    Vue.set(p,'shemalani',lanishema)

                    if(p.maticnaStranka&&p.maticnaStranka!=p.mso&&!(/000$/).test(p.maticnaStranka))
                        p.jedislocirana=true;
                    
                    if(shema=="EKO PRE") {
                        Vue.set(p,'glavnadejavnost',p.proizvod.find(pr=>pr.glavna)?.sifrant);
                        tempshema.vrstapredelovalca=tempshema.vrstapredelovalca??"Predelovalec";
                        Vue.set(p,'proizvodprikaz',p.proizvod.map(pr=>pr.sifrant?.naziv+" ("+pr.statuspridelkanaziv+")").join(", "));
                    }

                    if(shema=="EKO PRI") {
                        if(lanishema)
                        p.statuslani=lanishema.status
                        

                        if(thisComp.dataSezona.sezona>2023)
                            p.eprijavaposlana=p.poslaneprijave?.filter(p=>p.pravice=="prijavaeko_"+(thisComp.dataSezona.sezona-1))?.length>0;
                        if(thisComp.dataSezona.sezona>2023)
                        p.eprijavaoddana=p.prijave?.filter(p=>p.shema==shema)?.length>0;

                        if(thisComp.dataSezona.sezona>2023)
                            p.popolnaprijava=tempshema?.prijava?.popolna;

                        p.eprijavastatus={eprijavaposlana:p.eprijavaposlana,popolnaprijava:p.popolnaprijava,eprijavaoddana:p.eprijavaoddana};
                        //vzami kontakt iz nosilca...
                        //preveri, če je isti, kot v obrazcu
                        //tel, email in spletna stran!

                        let kontakt=p.kontakt.find(k=>k.vloga=="nosilec kmg");
                        if(!kontakt)
                            kontakt=p.kontakt.find(k=>k.glavni);
                        if(!kontakt)
                            kontakt=p.kontakt[0];

                        let nosilecddk=p.kontakt.find(k=>k.vloga=="nosilec dopolnilne dejavnosti na kmg");
                        Vue.set(p,"nosilecddk",false)
                        if(nosilecddk) {
                            Vue.set(p,"nosilecddk",true)
                            p.naziv=nosilecddk.naziv;
                        }
                        Vue.set(p,"spremembapodatkov",false)
                        if(thisComp.dataSezona.sezona>2023){
                            let eprijava=p.prijave.filter(i=>i.shema=='EKO PRI'&&i.sezona==sezona-1).sort((a,b)=>(new Date(b.updatedAt)-new Date(a.updatedAt)))[0]   
                            if(eprijava){
                                
                              
                            if(kontakt.telefon!=eprijava.prijava.kontakt.telefon){
                                
                                Vue.set(p,"spremembapodatkov",true)
                                console.log("SPREMEMBA")
                                console.log(kontakt.telefon)
                                console.log(eprijava.prijava.telefon)
                            }
                        }
                        
                        }


                        
                        

                        Vue.set(p,"spletnastran",p.kontakt.reduce((p,c,i)=>{
                            if(!p)
                                p=c.spletnastran;
                            return p;
                        },''))
                        Vue.set(p,"telefon",p.kontakt.reduce((p,c,i)=>{
                            if(!p)
                                p=c.telefon?.join(",");
                            return p;
                        },''))
                        Vue.set(p,"email",p.kontakt.reduce((p,c,i)=>{
                            if(!p)
                                p=c.email?.join(",");
                            return p;
                        },''))

                    }


                     if(shema=="IP") {
                        p.ippodrocja=tempshema.ip.podrocjacertificiranja.filter(pp=>pp.status.id==1).map(pp=>pp.naziv).join(" ");    
                        var ooseba=tempshema.ip.osebe.find(o=>true);
                       
                        Vue.set(p,'telefonoo',ooseba?.telefon)
                        Vue.set(p,'emailoo',ooseba?.email)
                        
                        p.popolnaprijava=tempshema.ip?.prijava?.popolna;
                        if(thisComp.dataSezona.sezona>2023)
                            p.eprijavaposlana=p.poslaneprijave?.filter(p=>p.pravice=="prijavaip_"+(thisComp.dataSezona.sezona-1))?.length>0;
                        if(thisComp.dataSezona.sezona>2023)
                            p.eprijavaoddana=p.prijave?.filter(p=>p.shema==shema)?.length>0;

                        if(p.eprijavaposlana&&!p.popolnaprijava){
                            let lanskashema=p.sheme.find(s=>s.shema==shema&&s.sezona==(thisComp.dataSezona.sezona-1));
                            if(lanskashema){
                            var ooseba=lanskashema.ip.osebe.find(o=>true);
                            Vue.set(p,'telefonoo',ooseba?.telefon)
                            Vue.set(p,'emailoo',ooseba?.email)
                            }
                        }

                        p.eprijavastatus={eprijavaposlana:p.eprijavaposlana,popolnaprijava:p.popolnaprijava,eprijavaoddana:p.eprijavaoddana};
                        for(let podshema of this.ipsheme){
                            let obsegpodsheme=tempshema?.ip?.prijava?.obseg;
                            if(!obsegpodsheme){
                                obsegpodsheme={};
                                console.log(p);
                            }   
                        
                            let gerki=p.gerki.filter(g=>g.sezona==thisComp.dataSezona.sezona&&g?.kontrolaIP);
                            let vsota=gerki.reduce((a,c)=>{return a+=c.povrsina; },0)
                            Vue.set(p,'povrsinaIP',vsota.toFixed())
                        
                        


                            obsegpodsheme=obsegpodsheme[podshema.naziv];
                            if(obsegpodsheme&&Array.isArray(obsegpodsheme)){
                                p[podshema.naziv+"_array"]=obsegpodsheme.map(o=>o.naziv)
                                p[podshema.naziv]=p[podshema.naziv+"_array"].join(', ')
                                p[podshema.naziv+"_sifra_array"]=obsegpodsheme.map(o=>o.šifra)
                                p[podshema.naziv+"_sifra"]=p[podshema.naziv+"_sifra_array"].join(', ')
                            }

                        }
                        }
                    
                   
                    p.id=tempshema.kontrolnaStevilka;
                    //Vue.set(p,"id",shema.kontrolnaStevilka);
                }
                

            thisComp.filter={
                logic: "and",
                filters: [
                    { field: "jeaktivna", operator: "neq", value: 0}
                ]
            };
            thisComp.ukazi=thisComp.sheme.find(i=>i.kratica==shema).ukazi;
            const dataState = {
            skip: thisComp.skip,
            take: thisComp.take,
            sort: thisComp.sort,
             filter: thisComp.filter,
            group: thisComp.group
        };
        thisComp.dataResult = process( thisComp.pridelava, dataState);

        thisComp.loading=false;
            if(next)
                next();
        });
            
            
        });         
        });

        },
         skrijStolpec: function(e) {
            let column=this.columns.find(c=>c.field==e.dataItem.field)
            if(column)
            column.hidden=true;
                const dataState = {
            skip: this.skip,
            take: this.take,
             filter: this.filter,
            sort: this.sort,
            group: this.group
        };
        this.dataResult = process( this.pridelava, dataState);
           
        },
        
      
        prikaziStolpec: function(e) {
           let column=this.columns.find(c=>c.field==e.dataItem.field)
            if(column)
            column.hidden=false;
                const dataState = {
            skip: this.skip,
            take: this.take,
            sort: this.sort,
             filter: this.filter,
            group: this.group
        };
        this.dataResult = process( this.pridelava, dataState);
        },
        sezonaChange(event) {
            const sezona = event.value;
            this.dataSezona=sezona;
            this.$router.push({ path: this.$route.path, query: { sezona:sezona.sezona,title:this.$route.query.title} })
            
            //this.naloziPodatke(this.$route.query.title)//{
            //this.loadShema({sezona:this.dataSezona.sezona,shema:this.$route.query.title});
            
     


        },

        
        createAppState: function(dataState) {
           
            this.take = dataState.take;
            this.skip = dataState.skip?dataState.skip:0;
            if (dataState.group) {
                dataState.group.map(group => group.aggregates = this.aggregates);
            }
            this.group = dataState.group;
            this.filter = dataState.filter;
            this.sort = dataState.sort;
           
        },

        dataStateChange (event) {
            this.createAppState(event.data);
           
            this.dataResult = process(this.pridelava, {
                skip: this.skip,
                take: this.take,
                sort: this.sort,
                filter: this.filter,
                group: this.group
            });
          

        },
        formatDate: function (h, emptyElement , props, listeners ) {
          
             return h('td', {attrs:{colspan:1}}, [kendo.toString(kendo.parseDate(props.dataItem[props.field]),'d')]);
        },
        dodajPridelovalca(){

              this.$router.push({ name: 'dodajStranko'})

        },
        exportExcel () {
            
            this.saveExcel({
                data: process(this.pridelava, {
                
                sort: this.sort,
                filter: this.filter,
                group: this.group
            }).data,
                fileName:this.dataSezona.sezona+ "_"+this.$route.query.title,
                columns: this.columns.filter(i=>!i.hidden)
            });
        },

         pageChangeHandler: function(event) {
            
            this.skip = event.page.skip;
            this.take = event.page.take;
           
        },
        filterKategorijaChange: function(ev) {

          
            

              const dataState = {
            skip: this.skip,
            take: this.take,
            sort: this.sort,
             filter: this.filter,
            group: this.group
        };
        this.dataResult = process( this.pridelava, dataState);
        },
        
    }
};
</script>

